import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Radio, Rectangle, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';

const AvailabilityFormOption = ({ isChecked, onClick, statusValue }) => (
  <>
    <div>
      <Rectangle
        fill={`availability_${statusValue}`}
        radius="circle"
        style={{ height: 6, width: 6 }}
      />
    </div>
    <Cushion vertical="xsmall">
      <Typography
        align="left"
        preset="name"
        component="div"
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <Trans i18nKey={`common:availability_${statusValue}`}>{statusValue}</Trans>
      </Typography>
    </Cushion>
    <div
      aria-label={statusValue}
      role="button"
      onKeyDown={onClick}
      onClick={onClick}
      tabIndex={0}
      style={{ cursor: 'pointer' }}
    >
      <Radio
        checkedBgColor="primary"
        input={{ name: 'availability_status', value: statusValue }}
        checked={isChecked}
      />
    </div>
  </>
);

AvailabilityFormOption.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  statusValue: PropTypes.oneOf(['available', 'not_sure', 'unavailable']).isRequired,
};

export default AvailabilityFormOption;
